export default __webpack_public_path__ + "static/media/Lightsaber Luke ROTJ - Img - Wip 5_14.17e525d7.jpg";